// extracted by mini-css-extract-plugin
export default {"rsidebar":"uJSCZWE3x76XfT8U4uBd","tags":"BZgdf47pTCkQpGcDVLL0"};